module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/selected-sold-property-pin-80a62a60c9f4bb94abdc6e70c927886f.svg";